import { IconDeviceLaptop } from "@repo/ui/icons";
import { DiagramSlide, type StepDef } from "./DiagramSlide";
import type { NodeDef } from "@components/architecture-data";

const DEVELOPER_NODE: NodeDef = {
  id: "developer",
  color: "violet",
  icon: IconDeviceLaptop,
  label: "Developer",
  desc: "",
  x: 1540,
  y: 88,
  layers: ["all"],
};

const STEPS: StepDef[] = [
  {
    key: "develop",
    label: "Develop",
    nodes: new Set(["developer", "gitlab"]),
    arrows: [{ from: "developer", to: "gitlab", color: "#a78bfa" }],
    caption: "Developer or agent pushes code",
  },
  {
    key: "build",
    label: "Build",
    nodes: new Set([
      "gitlab",
      "runners",
      "pkgreg",
      "ctrreg",
      "snapdp",
      "cpapi",
    ]),
    arrows: [
      { from: "gitlab", to: "runners", color: "#fb923c" },
      { from: "runners", to: "pkgreg", color: "#fb923c" },
      { from: "runners", to: "ctrreg", color: "#fb923c" },
      { from: "runners", to: "snapdp", color: "#60a5fa" },
      { from: "runners", to: "cpapi", color: "#60a5fa" },
    ],
    caption:
      "Custom runners build project and publish artifacts/containers",
  },
  {
    key: "test",
    label: "Test",
    nodes: new Set(["runners", "emulators", "snapdp", "gitlab"]),
    arrows: [
      { from: "runners", to: "emulators", color: "#fb923c" },
      { from: "emulators", to: "snapdp", color: "#60a5fa" },
      { from: "runners", to: "gitlab", color: "#fb923c" },
    ],
    caption:
      "Build is deployed and automatically tested in pipeline",
  },
  {
    key: "test-verify",
    label: "Test & Verify",
    nodes: new Set(["developer", "emulators", "cpapi", "webconsole"]),
    arrows: [
      {
        from: "developer",
        to: "emulators",
        color: "#a78bfa",
        bidirectional: true,
      },
      {
        from: "emulators",
        to: "cpapi",
        color: "#60a5fa",
        bidirectional: true,
      },
      {
        from: "cpapi",
        to: "webconsole",
        color: "#60a5fa",
        bidirectional: true,
      },
    ],
    caption:
      "Developers connect to cloud emulators for interactive verification",
  },
];

export function SoftwareFactorySlide() {
  return (
    <DiagramSlide
      title="Software Factory"
      subtitle="End-to-end automated pipeline from code commit to validated release"
      steps={STEPS}
      extraNodes={[DEVELOPER_NODE]}
    />
  );
}
